// 浏览器记住的界面偏好（每页行数、侧栏折叠）。隐私模式等存储不可用时读回 null、写入忽略：只影响下次打开时的默认值。

/** 读一项偏好，读不到或存储不可用时返回 null。 */
export function readPref(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

/** 写一项偏好，存储不可用时忽略。 */
export function writePref(key: string, value: string) {
  try {
    localStorage.setItem(key, value);
  } catch {
    // 只影响下次打开时的默认值
  }
}
